import { Pipe, PipeTransform } from '@angular/core';
import { Immagine} from '../models';

@Pipe({
 name: 'immagine'
})

export class ImmaginePipe implements PipeTransform {
/**
 * 
 * @param  {string} value
 */
transform(value: string): string {
    if (value != null) {
        let tmp = value.split(';');
        if (tmp[0] != null && tmp[0].length > 0) {
            return tmp[0];
        }
    }

    return "./assets/img/sentieri_default.jpg";
   }
}